// extracted by mini-css-extract-plugin
export default {"mobile-header":"header_mobile-header__n4s04","logo":"header_logo__oPYVl","lang-wrapper":"header_lang-wrapper__X+Z14","bold":"header_bold__QarHW","lang":"header_lang__+A393"};